<template>
  <el-card>
    <el-form class="global-form2" :model="formData" ref="form" :rules="rules" label-width="120px">
      <el-form-item label="项目名称" prop="projectId">
        <el-select v-model="formData.projectId" :disabled="contractId" placeholder="请选择所属项目">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="contractName" label="合同名称">
        <el-input v-model="formData.contractName" :disabled="contractId" placeholder="请输入合同名称"></el-input>
      </el-form-item>
      <el-form-item prop="startDate" label="开始日期">
        <el-date-picker v-model="formData.startDate" :disabled="contractId" value-format="yyyy-MM-dd" type="date" placeholder="请选择开始日期"></el-date-picker>
      </el-form-item>
      <el-form-item prop="endDate" label="结束日期">
        <el-date-picker v-model="formData.endDate" :disabled="contractId" value-format="yyyy-MM-dd" type="date" placeholder="请选择结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item prop="contractAmount" label="合同总额">
        <el-input v-model="formData.contractAmount" :disabled="contractId" placeholder="请输入合同总额"></el-input>
      </el-form-item>
      <el-form-item prop="maintainLevel" label="养护等级">
        <el-select v-model="formData.maintainLevel" placeholder="请选择养护等级">
          <el-option v-for="item in maintainLevelList" :key="item.dicCode" :label="item.dicValue":value="item.dicCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="plan" prop="planBackList" label="回款计划">
        <el-table :data="formData.planBackList" border>
          <el-table-column prop="planBackDate" label="计划回款日期">
            <template v-slot="{ row, $index }">
              <el-form-item v-if="row.edit" :show-message="false" inline-message :prop="`planBackList.${$index}.planBackDate`"
                :rules="[{ required: true, message: '请选择计划回款日期' }]">
                <el-date-picker v-model="row.planBackDate" value-format="yyyy-MM-dd" type="date" placeholder="请选择计划回款日期"></el-date-picker>
              </el-form-item>
              <span v-else>{{ row.planBackDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="planBackAmount" label="计划回款额（元）">
            <template v-slot="{ row, $index }">
              <el-form-item v-if="row.edit" inline-message :prop="`planBackList.${$index}.planBackAmount`"
                :rules="[{ required: true, message: '请输入计划回款额' }, { validator: twoDecimal }]">
                <el-input v-model="row.planBackAmount" placeholder="请输入计划回款额"></el-input>
              </el-form-item>
              <span v-else>{{ row.planBackAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="{ row, $index }">
              <template v-if="row.edit">
                <el-button type="text" @click="onSave(row, $index)">保存</el-button>
                <el-button type="text" @click="onCancel(row, $index)">取消</el-button>
              </template>
              <template v-else>
                <el-button type="text" v-if="!row.disabled" @click="onEdit(row)">编辑</el-button>
                <el-button type="text" v-if="!(row.actualBackAmount > 0)" @click="onDelete($index)">删除</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-button icon="el-icon-plus" type="text" @click="onAdd">添加回款计划</el-button>
      </el-form-item>
      <el-form-item prop="fileList" label="合同文件">
        <file-upload v-model="formData.fileList" accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx"></file-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { deepClone } from '@/utils/util'
import { twoDecimal } from '@/utils/validate'
import FileUpload from '@/components/FileUpload.vue'
export default {
  name: 'YhContractAdd',
  components: {
    FileUpload
  },
  data() {
    return {
      twoDecimal,
      maintainLevelList: [],
      formData: {
        projectId: '',// 项目ID
        startDate: '',// 劳务开始日期
        contractName: '',// 合同名称
        endDate: '',// 劳务结束日期
        contractAmount: '',// 合同金额
        maintainLevel: '',// 养护等级(字典类型maintainLevel)
        planBackList: [], // 回款计划列表
        // planBackList[].planBackDate: '',// 计划回款日期
        // planBackList[].planBackAmount: '',// 计划回款金额
        fileList: [] // 附件列表
      },
      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'change' }
        ],
        contractName: [
          { required: true, message: '请输入合同名称', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ],
        contractAmount: [
          { required: true, message: '请输入合同总额', trigger: 'blur' },
          { validator: twoDecimal, trigger: 'blur' }
        ],
        maintainLevel: [
          { required: true, message: '请选择养护等级', trigger: 'change' }
        ],
        planBackList: [
          { required: true, type: 'array', message: '请添加回款计划', trigger: 'change' }
        ],
        fileList: [
          { required: true, message: '请上传合同文件', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    },
    contractId() {
      return this.$route.query.contractId
    }
  },
  created() {
    this._tempRow = null
    if (this.contractId) {
      this.loadData()
    }
    this.loadDict()
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.operate.selectContractByContractId, {
        contractId: this.contractId
      }).then((res) => {
        res.planBackList.forEach(item => {
          item.edit = false
        })
        this.formData = res
      })
    },
    loadDict () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'maintainLevel' }).then(res => {
        this.maintainLevelList = res.maintainLevel || []
      })
    },
    onSubmit() {
      if (this.formData.planBackList.some(item => item.edit)) {
        this.$message.warning('请先保存回款计划')
        return
      }
      this.$refs.form.validate().then(() => {
        console.log('执行了吗')
        let url = this.$apis.operate.insertContract
        if (this.contractId) {
          url = this.$apis.operate.updateContract
        }
        const formData = deepClone(this.formData)
        formData.planBackList.forEach(item => {
          delete item.edit
        })
        this.$axios.post(url, formData).then(() => {
          this.$message.success('保存成功')
          this.$router.back()
        })
      })
    },
    onSave(row, index) {
      let errorMsg = ''
      this.$refs.form.validateField([
        `planBackList.${index}.planBackDate`,
        `planBackList.${index}.planBackAmount`
      ], error => {
        errorMsg = error
      })
      if (!errorMsg) {
        row.edit = false
      }
    },
    onEdit(row) {
      this._tempRow = deepClone(row)
      row.edit = true
    },
    onCancel(row, index) {
      if (row.planBackId) {
        this.formData.planBackList.splice(index, 1, this._tempRow)
      } else {
        this.formData.planBackList.splice(index, 1)
      }
    },
    onDelete(index) {
      this.formData.planBackList.splice(index, 1)
    },
    onAdd() {
      this.formData.planBackList.push({
        planBackDate: '',
        planBackAmount: '',
        edit: true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.plan {
  ::v-deep {
    .el-form-item {
      margin-bottom: 0;

      .el-input {
       width: 100% !important;
     }
    }
  }
}
</style>
